module.exports = __webpack_public_path__ + "img/logo.7475c041.png";